/* ==========================================================================
   SERPROMAQ - LÓGICA DE NAVEGACIÓN, HEADER STICKY Y SMOOTH SCROLLING
   ========================================================================== */

export function initNavigation() {
  const navbar = document.querySelector('.navbar');
  const mobileToggle = document.getElementById('mobileToggle');
  const drawerClose = document.getElementById('drawerClose');
  const mobileDrawer = document.getElementById('mobileDrawer');
  const mobileDrawerOverlay = document.getElementById('mobileDrawerOverlay');
  const navLinks = document.querySelectorAll('.nav-link, .drawer-link, .footer-link, a[href^="#"]');

  const headerHeight = 80;

  // 1. Sticky Navbar & Active Link Highlight (ScrollSpy)
  const handleScroll = () => {
    const scrollY = window.pageYOffset || document.documentElement.scrollTop;

    if (scrollY > 40) {
      navbar?.classList.add('scrolled');
    } else {
      navbar?.classList.remove('scrolled');
    }

    const sections = document.querySelectorAll('section[id]');

    sections.forEach(current => {
      const sectionHeight = current.offsetHeight;
      const sectionTop = current.offsetTop - headerHeight - 40;
      const sectionId = current.getAttribute('id');

      if (scrollY >= sectionTop && scrollY < sectionTop + sectionHeight) {
        document.querySelectorAll('.nav-link').forEach(l => {
          if (l.getAttribute('href') === `#${sectionId}`) {
            l.classList.add('active');
          } else {
            l.classList.remove('active');
          }
        });
      }
    });
  };

  window.addEventListener('scroll', handleScroll, { passive: true });
  handleScroll(); // Initial check

  // 2. Smooth Scrolling to Hash Anchors with Header Offset
  navLinks.forEach(link => {
    link.addEventListener('click', (e) => {
      // Ignorar si es un disparador de modal de cotización o acción especial
      if (link.matches('.btn-trigger-quote, [data-trigger-quote], .btn-quote-item, [href="#cotizar"], [href="#quoteModal"]')) {
        return;
      }

      const href = link.getAttribute('href');

      if (href && href.startsWith('#') && href.length > 1 && !href.startsWith('#quote') && !href.startsWith('#cotiz')) {
        const targetSection = document.querySelector(href);

        if (targetSection) {
          e.preventDefault();
          closeDrawer();

          // Si es una sección fullpage snap, su posición exacta es offsetTop
          const isSnap = targetSection.classList.contains('snap-section');
          const targetPosition = isSnap ? targetSection.offsetTop : (targetSection.getBoundingClientRect().top + window.pageYOffset - headerHeight);

          window.scrollTo({
            top: targetPosition,
            behavior: 'smooth'
          });

          // Update URL without harsh jump
          history.pushState(null, '', href);
        }
      }
    });
  });

  // 3. Mobile Drawer Toggle
  const openDrawer = () => {
    mobileDrawer?.classList.add('open');
    mobileDrawerOverlay?.classList.add('open');
    document.body.style.overflow = 'hidden';
  };

  const closeDrawer = () => {
    mobileDrawer?.classList.remove('open');
    mobileDrawerOverlay?.classList.remove('open');
    document.body.style.overflow = '';
  };

  mobileToggle?.addEventListener('click', openDrawer);
  drawerClose?.addEventListener('click', closeDrawer);
  mobileDrawerOverlay?.addEventListener('click', closeDrawer);

  // 4. Modales Legales: Términos y Condiciones & Política de Privacidad
  const termsModal = document.getElementById('termsModal');
  const btnOpenTerms = document.getElementById('btnOpenTerms');
  const btnCloseTermsModal = document.getElementById('btnCloseTermsModal');
  const btnOkTermsModal = document.getElementById('btnOkTermsModal');

  const privacyModal = document.getElementById('privacyModal');
  const btnOpenPrivacy = document.getElementById('btnOpenPrivacy');
  const btnClosePrivacyModal = document.getElementById('btnClosePrivacyModal');
  const btnOkPrivacyModal = document.getElementById('btnOkPrivacyModal');

  const openModal = (modal) => {
    if (!modal) return;
    modal.classList.add('active');
    document.body.style.overflow = 'hidden';
  };

  const closeModal = (modal) => {
    if (!modal) return;
    modal.classList.remove('active');
    document.body.style.overflow = '';
  };

  btnOpenTerms?.addEventListener('click', () => openModal(termsModal));
  btnCloseTermsModal?.addEventListener('click', () => closeModal(termsModal));
  btnOkTermsModal?.addEventListener('click', () => closeModal(termsModal));
  termsModal?.addEventListener('click', (e) => {
    if (e.target === termsModal) closeModal(termsModal);
  });

  btnOpenPrivacy?.addEventListener('click', () => openModal(privacyModal));
  btnClosePrivacyModal?.addEventListener('click', () => closeModal(privacyModal));
  btnOkPrivacyModal?.addEventListener('click', () => closeModal(privacyModal));
  privacyModal?.addEventListener('click', (e) => {
    if (e.target === privacyModal) closeModal(privacyModal);
  });

  // 3. Sincronización inteligente de videos Hero (Desktop vs Móvil)
  const syncHeroVideos = () => {
    const desktopVideo = document.querySelector('.hero-video-desktop');
    const mobileVideo = document.querySelector('.hero-video-mobile');
    const isMobile = window.innerWidth <= 991;

    if (isMobile) {
      if (desktopVideo && !desktopVideo.paused) desktopVideo.pause();
      if (mobileVideo && mobileVideo.paused) {
        mobileVideo.play().catch(() => {});
      }
    } else {
      if (mobileVideo && !mobileVideo.paused) mobileVideo.pause();
      if (desktopVideo && desktopVideo.paused) {
        desktopVideo.play().catch(() => {});
      }
    }
  };

  window.addEventListener('resize', syncHeroVideos, { passive: true });
  syncHeroVideos();
}
